module.exports = __webpack_public_path__ + "static/media/enex-gray.8a033d73.svg";